export default function getPayload() {
  if (typeof global.__PAYLOAD__ === 'undefined') {
    throw new Error('JS payload not defined');
  }

  return global.__PAYLOAD__;
}



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/utils/getPayload.js
 **/